import content from 'constants/content';
import nonReturnableList, { returnableKeys } from 'constants/non-returnable';
import { NonReturnable } from '../../types/NonReturnable';

const combinedContent = {
  ...content,
  ...nonReturnableList,
};

export const renderContent = (id: string) => {
  const contentValue = combinedContent[`${id}`];

  if (contentValue === undefined) return '';

  return contentValue;
};

export const renderContentWithParams = ({ id, params }: { id: string; params: string[] }) => {
  let contentValue = content[`${id}`];

  if (contentValue === undefined) return '';

  if (params) {
    params.forEach((param, index) => {
      contentValue = contentValue.replace(`{${index}}`, param);
    });
  }

  return contentValue;
};

export const getReturnable = (returnableKey: string): NonReturnable | undefined => {
  if (!returnableKeys.includes(returnableKey)) return undefined;
  return {
    beforeLink: renderContent(`nonReturnable.${returnableKey}.beforeLink`),
    link: {
      text: renderContent(`nonReturnable.${returnableKey}.link.text`),
      href: renderContent(`nonReturnable.${returnableKey}.link.href`),
    },
    key: returnableKey,
  };
};

export const formatPrice = (site: string, price: number) => {
  if (price === 0) return 'FREE';
  return site === 'veryie' ? `€${price}` : `£${price}`;
};

export const getPrice = (
  type: string,
  fallbackPrices: Record<string, number>,
  deliveryPrices: { type: string; value: number }[],
): number =>
  // eslint-disable-next-line security/detect-object-injection
  deliveryPrices.find((price) => price.type === type)?.value ?? fallbackPrices[type];
